module.exports = __webpack_public_path__ + "img/screen5.3402484e.png";